import * as yup from "yup";

export const ProductsValidation = yup.object().shape({
    name: yup
        .string()
        .required("Product name is required")
        .min(2, "Product name must be at least 2 characters")
        .max(100, "Product name must not exceed 100 characters")
        .trim(),
    
    image_url: yup
        .string()
        .nullable()
        .optional(),
    
    price: yup
        .number()
        .required("Price is required")
        .positive("Price must be a positive number")
        .typeError("Price must be a valid number"),
    
    description: yup
        .string()
        .max(1000, "Description must not exceed 1000 characters")
        .nullable()
        .optional(),
    
    is_active: yup
        .boolean()
        .default(true)
}); 